import { render } from "./[brandId].vue?vue&type=template&id=00f2e1a4"
import script from "./[brandId].vue?vue&type=script&lang=js"
export * from "./[brandId].vue?vue&type=script&lang=js"

import "./[brandId].vue?vue&type=style&index=0&id=00f2e1a4&lang=scss"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__